import { Stack, Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { Avatar } from '../suppliercontacts/Avatar';
import { Contact } from '../types';

const ContactOptionRender = () => {
    const record: Contact | undefined = useRecordContext();
    if (!record) return null;
    return (
        <Stack direction="row" gap={1} alignItems="center">
            <Avatar record={record} />
            <Stack>
                {record.nome_contato}
                <Typography variant="caption" color="text.secondary">
                    {record.desc_tipo}
                    {record.desc_tipo && record.nome_cliente && ' at '}
                    {record.nome_cliente}
                </Typography>
            </Stack>
        </Stack>
    );
};
export const contactOptionText = <ContactOptionRender />;
export const contactInputText = (choice: {
    nome_contato: string;
    nome_cliente: string;
}) => `${choice.nome_contato} - ${choice.nome_cliente}`;
